
import Vue from 'vue';
import Component from 'vue-class-component';
import UyapStatusCard from '@/components/home/UyapStatusCard.vue';
import UsageGuideCard from '@/components/home/UsageGuideCard.vue';
import EicraproLaunchCard from '@/components/home/EicraproLaunchCard.vue';

/**
 * Durum ve eylem yan yana: soldaki kart "ne durumdayım", sağdaki "ne yapabilirim".
 * Kılavuz altta tam genişlikte — nadiren açılıyor ve açıldığında geniş yer istiyor.
 *
 * Breakpoint yok (md/sm kaldırıldı): pencere Electron'da minWidth 900'e sabit,
 * daha dar bir düzenin oluşacağı bir durum yok. Sabit 8/4 daha az yalan söylüyor.
 */
@Component({
  components: {
    UyapStatusCard,
    EicraproLaunchCard,
    UsageGuideCard,
  },
})
export default class HomeView extends Vue {}
